import React, { Component } from 'react'
import { Link } from 'react-router'
import { HeaderView } from '@merchant-backend/common-components'
import style from './style.module.less'
import { MARKETING_CENTER_PATH } from '@constant'

const list = [
  {
    q: '什么是电子发票？',
    a: `电子发票是在购销商品、提供或者接受服务以及从事其他经营活动中，开具、收取的以电子方式存储的收付款凭证。<br/><br/>
      电子发票为真实有效的合法发票，与传统纸质发票具有同等法律效力。电子发票可以用于财务报销、保修和维权。<br/><br/>
      根据国家税务总局公告2015年84号《关于推行通过增值税电子发票系统开具的增值税电子普通发票有关问题的公告》第三条：增值税电子普通发票的开票方和受票方需要纸质发票的，可以自行打印增值税电子普通发票的版式文件，其法律效力、基本用途、基本使用规定等与税务机关监制的增值税普通发票相同。`
  },
  {
    q: '发票的类型有哪些？',
    a: '目前可以开具电子增值税普通发票（电子）和增值税专用发票（纸质）。'
  },
  {
    q: '电子发票在哪里下载？',
    a: `审批通过后，会在填写的手机和邮箱中收到开票成功的信息：<br/>
      短信，打开链接即可查看并下载发票；<br/>
      邮件，点击查看发票即可查看并下载发票。
      `
  },
  {
    q: '增值税专用发票如何收到？',
    a: '审批通过后，会通过客户经理代送或快递（到付）寄送到您填写的收票地址中。'
  },
  {
    q: '为什么当我选择开具单位抬头发票时，需要填写纳税人识别号？',
    a: `国家税务总局公告2017年第16号规定：自2017年7月1日起，购买方为企业的，索取增值税普通发票时，应向销售方提供纳税人识别号或统一社会信用代码；销售方为其开具增值税普通发票时，应在“购买方纳税人识别号”栏填写购买方的纳税人识别号或统一社会信用代码。不符合规定的发票，不得作为税收凭证。<br/><br/>
    纳税人识别号有两种方式获取：①联系公司财务咨询开票信息；②登录全国组织代码管理中心查询`
  },
  {
    q: '电子发票如何在网上查验？',
    a: '可在浙江省国家税务局发票查验系统查询，网址为：http://www.zjtax.gov.cn/'
  }
]

const Q = ({ q, a }) => (
  <div className={style.block}>
    <p>问：{q}</p>
    <p dangerouslySetInnerHTML={{ __html: a }} />
  </div>
)

export default class extends Component {
  render() {
    const header = [
      <Link to={MARKETING_CENTER_PATH}>支付订单</Link>,
      '开票申请'
    ]

    return (
      <HeaderView header={header} title="常见问题">
        <div style={{ marginTop: 20 }}>
          {list.map((item, index) => <Q key={index} {...item} />)}
        </div>
      </HeaderView>
    )
  }
}
